// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/tabs/payment/payment.less
// module id = 3386
// module chunks = 0